/**
 * Fetches audience data from the Fusion API and pushes to dataLayer
 */
const audienceData = (function () {
	async function init() {
		try {
			let userIsLoggedIn = document.cookie.includes("AuthenticatedUser");

			if (!userIsLoggedIn) return; // User is not logged in, silently exit

			const response = await fetch(`${window.location.origin}/api/fusion/audiences`);

			if (response.status === 401) return; // User is logged out, silently exit

			if (!response.ok) throw new Error(`Audience API returned ${response.status}`);

			const data = await response.json();

			// Ensure dataLayer exists before pushing
			window.dataLayer = window.dataLayer || [];
			window.dataLayer.push({
				event: 'fusionAudiencesLoaded',
				fusionAudienceNames: data || [],
				fusionAudienceCount: data?.length || 0,
			});
		} catch (error) {
			console.error('Failed to fetch audience data:', error);
		}
	}

	return {
		init: init,
	};
})();

document.addEventListener('DOMContentLoaded', function () {
	audienceData.init();
});

// CommonJS export for testing
if (typeof module !== 'undefined' && module.exports) {
	module.exports = audienceData;
}
